<template>
  <div class="md-layout md-gutter md-size-100 md-alignment-center-center">
    <div class="md-layout-item md-size-45">
      <md-button class="md-fab md-primary btn-back" @click="prevStep">
        <md-icon>arrow_back</md-icon>
      </md-button>
    </div>
    <div class="md-layout-item md-size-10">
      <span>[{{ step }}\4]</span>
    </div>
    <div class="md-layout-item md-size-45">
      <md-button v-if="next !== undefined" class="md-fab md-primary btn-next" @click="nextStep()">
        <md-icon>arrow_forward</md-icon>
      </md-button>
      <md-button v-if="end !== undefined" class="md-fab md-primary btn-next" @click="save()">
        <md-icon>check</md-icon>
      </md-button>
    </div>
  </div>
</template>

<script>
import EventBus from '@/event-bus.js'
export default {
  props: ['prev', 'next', 'end', 'step'],
  methods: {
    save: function () {
      EventBus.$emit('save')
    },

    nextStep: function () {
      this.$parent.$emit('next')
    },

    prevStep: function () {
      this.$router.push(this.prev)
      if (this.step === '2') this.$emit('btnPrev')
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/style/arcadia_theme.scss';
</style>
